require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-aiib-urban-strategy-promote-adequate-standard-of-living.json") })
        }
      }, "path---en-us-update-aiib-urban-strategy-promote-adequate-standard-of-living");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-aiib-urban-strategy-promote-adequate-standard-of-living!./.cache/json/en-us-update-aiib-urban-strategy-promote-adequate-standard-of-living.json
// module id = 610
// module chunks = 231608221292675